module.exports = __webpack_public_path__ + "assets/images/lapin-studying-716a741e226b468d56b71d684743eac4.png";